import { MuiMaterials } from "../../@index.js";
import { getWindowChromeThemeColor } from "./windowChromeTheme.js";

/**
 * Site Grades–style content shell used by every main-menu modal body:
 *   - gray page margins come from ModalChrome's pageBg + the outer `px: 2` / `pt: 2` padding
 *   - the bordered tile matches Grades' gray panels (`#f8f8f8`/`#252525`, 8px radius, 16px pad)
 *
 * Put tab bars / intro text outside this tile when they should sit above it (like Grades' tabs);
 * put the scrollable working content inside.
 */
export default function ModalContentTile({ children, sx = null, className }) {
    const tileBg = getWindowChromeThemeColor("#f8f8f8", "#252525");
    const tileBorder = getWindowChromeThemeColor("#e0e0e0", "#3d3d3d");

    return (
        <MuiMaterials.Box
            className={className}
            sx={{
                width: "100%",
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                padding: "16px",
                marginBottom: "8px",
                background: tileBg,
                borderRadius: "8px",
                border: `1px solid ${tileBorder}`,
                overflow: "hidden",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "&::-webkit-scrollbar": { display: "none" },
                ...(sx || {}),
            }}
        >
            {children}
        </MuiMaterials.Box>
    );
}

/** Outer body padding shared by all main-menu modals — matches Site Grades (`px: 2`, `pt: 2`). */
export function ModalBody({ children, className, sx = null }) {
    return (
        <MuiMaterials.Box
            className={className ? `${className} hide-scrollbar` : "hide-scrollbar"}
            sx={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                width: "100%",
                alignItems: "stretch",
                overflow: "hidden",
                px: 2,
                pt: 2,
                pb: 1,
                color: getWindowChromeThemeColor("#333333", "#f4cc8e"),
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "&::-webkit-scrollbar": { display: "none" },
                ...(sx || {}),
            }}
        >
            {children}
        </MuiMaterials.Box>
    );
}
